import { render } from "./OnboardingTrialFinal.vue?vue&type=template&id=2a955c67&scoped=true"
import script from "./OnboardingTrialFinal.vue?vue&type=script&lang=js"
export * from "./OnboardingTrialFinal.vue?vue&type=script&lang=js"

import "./OnboardingTrialFinal.vue?vue&type=style&index=0&id=2a955c67&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a955c67"]])

export default __exports__